var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ editing: _vm.$store.state.edit },attrs:{"id":"app"}},[_c('Header'),_c('Map',{attrs:{"locations":_vm.locations,"doubleClickZoom":"true"}}),_c('slideout-panel'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }